import { Image } from '@shared/components/Image';
import { Signature, SignatureField } from '@shared/data/entity/fields/SignatureField';
import { useImageSrcAndDimensions } from '@shared/util/hooks';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';
import classNames from './SignatureCollectionViewField.module.css';

interface Props {
  field: SignatureField;
}

export function SignatureCollectionViewField({ field }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer fieldType={field.fieldType}>
      <SignatureImage image={field.signature} />
    </CardCollectionViewFieldContainer>
  );
}

function SignatureImage({ image }: { image: Signature }) {
  const { src } = useImageSrcAndDimensions({ image });
  return <Image source={{ uri: src }} className={classNames.image} />;
}
